<div [formGroup]="filterGroup" class="feed" id="feed">

    <div [class.filtered]="this.filterFormValue.sortBy || filterFormValue.search?.length || this.filterFormValue.isPinned != null || this.filterGroup.value['filterBy']"
         class="filtersRow">
        <mat-form-field appearance="fill" class="noBottomPadding searchFrom" color="accent">
            <mat-label>Search</mat-label>
            <input (keyup.enter)="applyFilters()" formControlName="search" matInput type="text"/>
            <mat-icon (click)="applyFilters()" class="cursorPointer" color="accent" matPrefix>
                search
            </mat-icon>
            <button (click)="clearSearch(); applyFilters()" *ngIf="filterFormValue.search?.length" aria-label="Clear"
                    mat-icon-button
                    matSuffix>
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="datePicker noBottomPadding dateRange" color="accent">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input (dateChange)="applyFilters()" formControlName="startDate" matStartDate placeholder="Start date">
                <input (dateChange)="applyFilters()" formControlName="endDate" matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle (click)="clearDate()" *ngIf="dateSet" matIconSuffix>
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
            <mat-date-range-picker #picker color="accent"></mat-date-range-picker>

            <mat-error *ngIf="filterGroup.controls['startDate'].hasError('matStartDateInvalid')">Invalid start date
            </mat-error>
            <mat-error *ngIf="filterGroup.controls['endDate'].hasError('matEndDateInvalid')">Invalid end date
            </mat-error>
        </mat-form-field>
        <div class="sortBtn">

            <button [appCustomButtonColours]="community?.sort_by_button_color_hex || 'var(--accent)'"
                    [matMenuTriggerFor]="sortfilters" aria-label="Sort by" color="accent"
                    mat-mini-fab
                    matTooltip="Sort by">
                <mat-icon>sort</mat-icon>
            </button>
            <mat-menu #sortfilters="matMenu">
                <button (click)="setFilters(option.value, 'sortBy')" *ngFor="let option of sortOptions"
                        [ngClass]="{'selectedBtn' : this.filterGroup.value['sortBy'] == option.value }"
                        mat-menu-item>{{ option.label }}
                </button>
            </mat-menu>
        </div>
        <div class="filterBtn">
            <button [appCustomButtonColours]="community?.filter_by_button_color_hex || 'var(--accent)'"
                    [matMenuTriggerFor]="filters" aria-label="Filter By" color="accent"
                    mat-mini-fab
                    matTooltip="Filter by">
                <mat-icon>filter_list</mat-icon>
            </button>
            <mat-menu #filters="matMenu">
                <button (click)="setFilters(option.value, 'filterBy')" *ngFor="let option of filterOptions"
                        [ngClass]="{'selectedBtn' : this.filterGroup.value['filterBy'] == option.value }"
                        mat-menu-item>{{ option.label }}
                </button>
            </mat-menu>
        </div>
        <div class="pinnedFilter">
            <button [appCustomButtonColours]="community?.filter_pinned_button_color_hex || 'var(--accent)'"
                    [matMenuTriggerFor]="pinnedFilter" aria-label="Filter pinned" color="accent"
                    mat-mini-fab
                    matTooltip="Filter pinned">
                <mat-icon svgIcon="thumbtackIcon"></mat-icon>
            </button>
        </div>
        <div *ngIf="this.filterFormValue.sortBy || filterFormValue.search?.length ||  this.filterFormValue.isPinned != null || this.filterGroup.value['filterBy']"
             class="clearFilters">
            <button (click)="location.reload()"
                    [appCustomButtonColours]="community?.clear_filters_button_color_hex || 'var(--accent)'"
                    aria-label="Clear Filters" color="accent"
                    mat-mini-fab
                    matTooltip="Clear filters">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-menu #pinnedFilter="matMenu">
            <button (click)="setFilters(option.value, 'isPinned')" *ngFor="let option of showPinnedOptions"
                    [ngClass]="{'selectedBtn' : this.filterGroup.value['isPinned'] === option.value }"
                    mat-menu-item>{{ option.label }}
            </button>
        </mat-menu>
    </div>
    <app-tab-selector (tabChange)="applyFilters($event)" [defaultValue]="setCategory" [options]="categoryOptions"
                      class="fullRowGrid"
                      formControlName="category"></app-tab-selector>
    <div *ngIf="this.isMobile" class="gap-10 flex-col pinnedPosts mt-10">
        <app-post-card
                (action)="loadPostFromSidebar(currentCommunityId)"
                *ngFor="let post of sidebarPosts; trackBy: trackByPostId"
                [hidePoll]="true"
                [post]="post"
                [reducedContent]="true"
                [showPinnedBadge]="false"
        ></app-post-card>
    </div>
    <div infiniteScroll
         [infiniteScrollDistance]="1"
         [infiniteScrollThrottle]="50"
         (scrolled)="triggerInfiniteScroll()">
        <ng-container *ngIf="content?.length; else emptyState">
            <app-post-card
                #postCard
                (action)="reloadContent()"
                (scrollFinished)="isRequiredScrollToPost(post.id) && postCard.startBlinkAnimation()"
                *ngFor="let post of content; trackBy: trackByPostId"
                [appScrollIntoView]="isRequiredScrollToPost(post.id)"
                [post]="post"
                [showPinnedBadge]="true"
                class="d-block my-10"
            ></app-post-card>
        </ng-container>
        <div *ngIf="loading" class="w-100 d-flex justify-content-center">
            <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
        </div>
    </div>
</div>

<ng-template #emptyState>
    <mat-card *ngIf="loading == false" class="my-10">
        <mat-card-content class="d-flex align-items-center justify-content-center">
            <div *ngIf="!filtersApplied" class="p-20">
                There are no posts in this community yet
            </div>
            <div *ngIf="filtersApplied" class="p-20">
                There are no posts in this community yet according to these filters
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
